import { Component } from '@angular/core';

import { SedsButtonTypeOptions } from '../../seds-buttons/enums/seds-button-type-options.enum';
import { SedsSquareButtonAbstractComponent } from '../../seds-buttons/seds-square-button-abstract';

@Component({
    selector: 'seds-flat-button',
    templateUrl: './seds-flat-button.component.html',
    styleUrls: ['./seds-flat-button.component.scss'],
    standalone: false
})
export class SedsFlatButtonComponent extends SedsSquareButtonAbstractComponent {
  colors: any = {
    primary: 'primary-flat-button',
    accent: 'accent-flat-button',
    secondary: 'secondary-flat-button',
    tertiary: 'tertiary-flat-button',
  };

  override type = SedsButtonTypeOptions.FLAT;
}
